import { useState } from "react"
import { storyblokEditable, renderRichText } from "@storyblok/react"
import { motion } from "framer-motion"
import FounderCover from "./FounderCover.png"

export default function VideoMessage({ blok }: any) {
  const [isPlaying, setIsPlaying] = useState(false)

  const raw =
    typeof blok.videoEmbed === "string"
      ? blok.videoEmbed
      : (renderRichText(blok.videoEmbed || { content: [] }) || "").toString()

  const normalized = raw
    .replace(/\s(width|height)="[^"]*"/g, "")
    .replace("<iframe", '<iframe class="w-full h-full"')

  return (
    <section
      {...storyblokEditable(blok)}
      className="bg-white py-24 md:py-28 px-6 md:px-12"
    >
      <div className="max-w-5xl mx-auto text-center">
        <div
          className="font-['BeausiteClassic'] font-bold text-[24px] md:text-[32px] text-gray-900 mb-4"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.heading || { content: [] }) || "",
          }}
        />
        <span className="mx-auto mb-10 block h-[3px] w-16 rounded-full bg-gradient-to-r from-[#4750F5] to-[#8BA3FF]" />
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
          className="relative aspect-video rounded-2xl overflow-hidden shadow-lg"
        >
          {!isPlaying ? (
            <button
              className="group absolute inset-0 w-full h-full flex items-center justify-center focus:outline-none"
              onClick={() => setIsPlaying(true)}
            >
              <img
                src={FounderCover}
                alt="Video preview cover"
                className="w-full h-full object-cover"
              />
              <div className="absolute flex items-center justify-center w-20 h-20 bg-white/90 rounded-full shadow-lg group-hover:scale-105 transition-transform">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#4750F5"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="#4750F5"
                  className="w-10 h-10"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5.25 5.653v12.694c0 .865.93 1.398 1.693.96l10.963-6.347a1.125 1.125 0 000-1.92L6.943 4.693a1.125 1.125 0 00-1.693.96z"
                  />
                </svg>
              </div>
            </button>
          ) : (
            <div
              className="absolute inset-0"
              dangerouslySetInnerHTML={{ __html: normalized }}
            />
          )}
        </motion.div>
        {blok.caption?.content?.length ? (
          <div
            className="mt-8 font-['BeausiteClassic'] text-base md:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.caption || { content: [] }) || "",
            }}
          />
        ) : null}
      </div>
    </section>
  )
}
